/* eslint-disable angular/controller-name, angular/controller-as */

/*
 * decaffeinate suggestions:
 * DS101: Remove unnecessary use of Array.from
 * DS102: Remove unnecessary code created because of implicit returns
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */

angular.
module("dx.webapp.register").
controller("DxRegisterDirectiveController", function registerDirectiveController(
	$rootScope,
	$scope,
	$window,
	$location,

	UIStateManager,
	validationService,
	faults,
	Auth,
	DX_URLS,

	dxLocalize
) {
	"use strict";

	$scope.Urls = DX_URLS;
	$scope.state = new UIStateManager("register");

	$scope.communicationTerms = false;
	$scope.communicationSystem = false;
	$scope.communicationProductUpdates = false;
	$scope.communicationPromotional = false;

	$scope.termsAccepted = false;
	$scope.firstnameValidation = {display: false, warning: false, error: false, success: false, message: dxLocalize.get("RequiredField")};
	$scope.lastnameValidation = {display: false, warning: false, error: false, success: false, message: dxLocalize.get("RequiredField")};
	$scope.emailValidation = {display: false, warning: false, error: false, success: false, message: dxLocalize.get("RequiredField")};
	$scope.confirmEmailValidation = {display: false, warning: false, error: false, success: false, message: dxLocalize.get("RequiredField")};
	$scope.passwordValidation = {display: false, warning: false, error: false, success: false, message: dxLocalize.get("RequiredField")};
	$scope.confirmPasswordValidation = {display: false, warning: false, error: false, success: false, message: dxLocalize.get("RequiredField")};

	function setValidationState(validationSet, validationState, message) {
		validationSet.message = message;
		switch (validationState) {
			case "warning":
				validationSet.display = true;
				validationSet.warning = true;
				validationSet.error = validationSet.success = false;
				break;
			case "error":
				validationSet.display = true;
				validationSet.error = true;
				validationSet.warning = validationSet.success = false;
				break;
			case "success":
				validationSet.display = false;
				validationSet.success = true;
				validationSet.warning = validationSet.error = false;
				break;
			default: return;
		}
	}

	$scope.$on("auth:registerfailed", function onAuthRegisterFailed(event, errors) {
		$scope.state.set("register");
		if (Array.from(errors).indexOf(faults.ALREADY_SIGNED_UP) >= 0) {
			// If the user is invited, show the registered mail in the warning
			if ($scope.invite) {
				setValidationState($scope.emailValidation, "warning", dxLocalize.get("InviteEmailAlreadyRegistered", $scope.invite.email));
			} else {
				setValidationState($scope.emailValidation, "warning", dxLocalize.get("EmailAlreadyRegistered"));
			}
		} else if (Array.from(errors).indexOf(faults.PASSWORD_TOO_SHORT) >= 0) {
			setValidationState($scope.passwordValidation, "warning", dxLocalize.get("PasswordTooShort"));
		} else if (Array.from(errors).indexOf(faults.PASSWORD_TOO_LONG) >= 0) {
			setValidationState($scope.passwordValidation, "warning", dxLocalize.get("PasswordTooLong"));
		} else if (Array.from(errors).indexOf(faults.PASSWORD_HAS_WHITESPACE) >= 0) {
			setValidationState($scope.passwordValidation, "warning", dxLocalize.get("PasswordWhitespace"));
		} else if (Array.from(errors).indexOf(faults.PASSWORD_COMMON) >= 0) {
			setValidationState($scope.passwordValidation, "warning", dxLocalize.get("PasswordCommon"));
		} else {
			$window.console.log("An unknown error occurred, faults:", errors);
			$rootScope.$broadcast("notification:error", dxLocalize.get("SomethingWentWrongLong"));
			$location.path(DX_URLS.get("overview"));
		}
	});

	$scope.checkFirstname = function checkFirstname() {
		$scope.firstnameValidation.display = true;
		if (typeof $scope.firstname === "undefined" || $scope.firstname.length === 0) {
			setValidationState($scope.firstnameValidation, "warning", dxLocalize.get("RequiredField"));
		} else if ($scope.firstname.length < 2) {
			setValidationState($scope.firstnameValidation, "warning", dxLocalize.get("MustBeLongerThan1Char"));
		} else {
			setValidationState($scope.firstnameValidation, "success", "");
		}
	};

	$scope.checkLastname = function checkLastname() {
		$scope.lastnameValidation.display = true;
		if (typeof $scope.lastname === "undefined" || $scope.lastname.length === 0) {
			setValidationState($scope.lastnameValidation, "warning", dxLocalize.get("RequiredField"));
		} else if ($scope.lastname.length < 2) {
			setValidationState($scope.lastnameValidation, "warning", dxLocalize.get("MustBeLongerThan1Char"));
		} else {
			setValidationState($scope.lastnameValidation, "success", "");
		}
	};

	$scope.checkEmail = function checkEmail() {
		$scope.emailValidation.display = true;

		if (!validationService.isEmailValid($scope.email, true)) { // eslint-disable-line no-negated-condition
			setValidationState($scope.emailValidation, "warning", dxLocalize.get("MustBeValidEmail"));
		} else {
			setValidationState($scope.emailValidation, "success", "");
		}

		if ($scope.confirmEmailValidation.display && $scope.email !== $scope.confirmEmail) {
			setValidationState($scope.confirmEmailValidation, "warning", "");
		} else if ($scope.confirmEmailValidation.display && $scope.email === $scope.confirmEmail) {
			setValidationState($scope.confirmEmailValidation, "success", "");
		}
	};

	$scope.checkConfirmEmail = function checkConfirmEmail() {
		$scope.confirmEmailValidation.display = true;

		if (!validationService.isEmailValid($scope.confirmEmail, true)) {
			setValidationState($scope.confirmEmailValidation, "warning", dxLocalize.get("MustBeValidEmail"));
		} else if ($scope.email !== $scope.confirmEmail) { // eslint-disable-line no-negated-condition
			setValidationState($scope.confirmEmailValidation, "warning", dxLocalize.get("EmailsAreNotAMatch"));
		} else {
			setValidationState($scope.confirmEmailValidation, "success", "");
		}
	};

	$scope.checkPassword = function checkPassword() {
		$scope.passwordValidation.display = true;

		if (typeof $scope.password === "undefined" || $scope.password.length === 0) {
			setValidationState($scope.passwordValidation, "warning", dxLocalize.get("RequiredField"));
		} else if ($scope.password.length < 6) {
			setValidationState($scope.passwordValidation, "warning", dxLocalize.get("MustBeLongerThan5Chars"));
		} else {
			setValidationState($scope.passwordValidation, "success", "");
		}

		if ($scope.confirmPasswordValidation.display && $scope.password !== $scope.confirmPassword) {
			setValidationState($scope.confirmPasswordValidation, "warning", dxLocalize.get("PasswordsAreNotAMatch"));
		} else if ($scope.confirmPasswordValidation.display && $scope.password === $scope.confirmPassword) {
			setValidationState($scope.confirmPasswordValidation, "success", "");
		}
	};

	$scope.checkConfirmPassword = function checkConfirmPassword() {
		$scope.confirmPasswordValidation.display = true;

		if (typeof $scope.confirmPassword === "undefined" || $scope.confirmPassword.length === 0) {
			setValidationState($scope.confirmPasswordValidation, "warning", dxLocalize.get("RequiredField"));
		} else if ($scope.confirmPassword.length < 6) {
			setValidationState($scope.confirmPasswordValidation, "warning", dxLocalize.get("MustBeLongerThan5Chars"));
		} else if ($scope.password !== $scope.confirmPassword) { // eslint-disable-line no-negated-condition
			setValidationState($scope.confirmPasswordValidation, "warning", dxLocalize.get("PasswordsAreNotAMatch"));
		} else {
			setValidationState($scope.confirmPasswordValidation, "success", "");
		}
	};

	$scope.canSubmit = function canSubmit() {
		return $scope.firstnameValidation.success &&
			$scope.lastnameValidation.success &&
			($scope.invite || $scope.emailValidation.success) &&
			($scope.invite || $scope.confirmEmailValidation.success) &&
			$scope.passwordValidation.success &&
			$scope.termsAccepted &&
			$scope.confirmPasswordValidation.success &&
			$scope.communicationSystem &&
			$scope.communicationTerms;
	};

	$scope.registerAccount = function registerAccount() {
		if ($scope.canSubmit()) {
			$scope.state.set("loading");

			var accountDetails = {
				firstname: $scope.firstname,
				lastname: $scope.lastname,
				email: $scope.invite ? $scope.invite.email : $scope.email,
				password: $scope.password,
				communicationTerms: $scope.communicationTerms,
				communicationSystem: $scope.communicationSystem,
				communicationProductUpdates: $scope.communicationProductUpdates,
				communicationPromotional: $scope.communicationPromotional,
			};

			Auth.register(accountDetails);
		}
	};
});
